export interface Resource {
	id: string;
	name: string;
	url: string;
	inMediaHandlingOnly: string;
	isPopup: boolean;
	queueId: string;
	autoOpenTrigger: AutoOpenTrigger;
}

export enum AutoOpenTrigger {
    Never = 0,
    WhenOffering = 1,
    WhenHandlingAccepted = 2,
    WhenClosed = 3
}
